// Hover Sectors
jq('.section-hover-sectors .sector-block').on('mouseover', function() {
    jq('.section-hover-sectors .sector-block').removeClass('hover');
    jq(this).addClass('hover');
});
jq('.section-hover-blocks .hover-block').on('mouseover', function() {
    jq('.section-hover-blocks .hover-block').removeClass('hover');
    jq(this).addClass('hover');
});

jq(window).load(function () {
    checkWidth();
    if (window.location.hash) {
        var hash = window.location.hash;
        goToByScroll(hash);
    } 
});